export default "__VITE_ASSET__HIY4lBdC__"